<template>
	<div>
		<div class="col-md-12">
			<div class="row" style="margin-top:20px">
				<div class="col-md-6">
					<h3 class="page-header">
						<i class="fa fa-linode animated bounceInDown show-info"></i>
						Create New Job
					</h3>
				</div>
				<div class="col-md-6 ">
					<div class="row">

					</div>
				</div>
			</div>
		</div>
		<div class="panel panel-cascade">
			<div class="panel-body">
				<div class="form-horizontal cascde-forms">
					<div class="col-md-12">
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Title<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<input type="text" class="form-control form-cascade-control input-small"
									v-model="title">
							</div>
						</div>
                        <div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Company<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<input type="text" class="form-control form-cascade-control input-small"
									v-model="companyname">
							</div>
						</div>
                        <div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Job Type</label>
							</div>
							<div class="col-md-6">
								<select class="form-control form-cascade-control input-small"
									v-model="jobtype">
									<option :value="0">Select</option>
									<option :value="1">Full Time</option>
									<option :value="2">Part time</option>
								</select>

							</div>
						</div>
                        <div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Salary<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<input type="text" class="form-control form-cascade-control input-small"
									v-model="salary">
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">City<span
										style="color: rgba(255, 0, 0, 0.67)">*</span></label>
							</div>
							<div class="col-md-6">
								<input type="text" v-model="city"
									class="form-control form-cascade-control input-small">
							</div>
						</div>

						<div class="form-group row">
							<div class="col-md-3">
								<label class="col-form-label ">Description</label>
							</div>
							<div class="col-md-6">
								<textarea class="form-control form-cascade-control input-small"
									v-model="description2" cols="30" rows="3"></textarea>
								<span class="invalid-feedback" role="alert">
									<strong></strong>
								</span>
							</div>
						</div>
						<div class="col-md-12  text-center">
							<div class="row">
								<div class="col-md-4"></div>
								<div class="col-md-2">
									<input type="button" class="btn btn-primary" value="Submit" @click="onSubmit()" />
								</div>
								<div class="col-md-2">
									<input type="button" class="btn btn-danger btn-sm" @click="cancel()" value="Cancel" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
import axios from 'axios';
import Constants from '../../components/utilities/Constants.vue';
import { mapGetters } from 'vuex';
export default {
	mixins: [Constants],
	props: ['editjob'],
	components: {

	},
	data() {
		return {
            id:0,
			title: '',
            companyname:'',
            jobtype: 0,
            salary:0,
            city:'',
            description2:''

		}
	},
	mounted() {
		this.initialize()
		// this.$store.dispatch('fetchPropertySubCategory')

	},

	computed: {
		...mapGetters([''])
	},

	methods: {
		initialize() {
            if(this.editjob!=null){
                this.id = this.editjob.id ?? 0
                this.title = this.editjob.title ?? ''
                this.companyname = this.editjob.companyname ?? ''
                this.city = this.editjob.cityname ?? ''
                this.salary = this.editjob.salary ?? ''
                this.description2 = this.editjob.description ?? ''
            }
		},
		onSubmit: function () {
			if (this.title == '') {
				this.$notify({ text: "Title is required.", type: "warn" })
			} else if (this.companyname == '') {
				this.$notify({ text: "Company is required.", type: "warn" })
			} else {
				let param = {
                    id : this.id,title : this.title,companyname : this.companyname,jobtype : this.jobtype,
                    salary : this.salary,city : this.city, description2 : this.description2
                }
				axios.post('api/jobs/createupdate', param)
					.then(response => {
						console.log(response.data);
						if (response.data==1) {
                            this.$notify({text:"Save successfully" , type: 'Success'})
							this.cancel();
						}
					})
					.catch(error => {
						console.log(error);
					});
			}


		},
		cancel() {
            this.id=0
            this.title = ''
            this.companyname=''
            this.city=''
            this.jobtype=0
            this.description2=''
            this.salary=0
            if (this.editjob != null) {
				this.$emit('close')
			}
		},


	}
}

</script>
